import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import _ from 'lodash';
import BaseModal from 'components/BaseModal';
import { LoadingIcon } from 'components/Icons';
import message from "components/CustomMessage";

function MSTeamsOAuthPopup({ afterClose: _afterClose }, ref) {
    const errorRef = useRef(false)
    const thisRef = useRef();
    const URL = "/user/tools/msteams/oauth/start";
    useImperativeHandle(ref, () => ({
        ...thisRef
    }),[])

    const afterClose = useCallback(() => {
        _afterClose && _afterClose(true);
    }, [_afterClose]);

    useEffect(() => {
        const _window = window.open(URL, "_blank", "width=1000,height=800,rel=noopener");
        if (_.isNull(_window)) {
            message.error("Pop-up window is blocked on your browser, please enable and retry.");
            afterClose()
            return false;
        }
        var timer = setInterval(function () {
            try {
                // _window becomes null if the popup window is blocked by the browser.
                // User closes the OAuth window before access
                if (!_window || _window.closed) {
                    clearInterval(timer);
                    message.error("Unable to connect to MS Teams, please try again.");
                    thisRef.current.close();
                    return;
                }
                if (_window.location.pathname.endsWith("success/oauth_redirect")) {
                    _window.close();
                    clearInterval(timer);
                    thisRef.current.close();
                }
            } catch (e) { errorRef.current = true }
        }, 1000);
        return () => {
            clearInterval(timer);
            _window.close();
        }
    }, [afterClose, URL]);

    return (
        <BaseModal
            modalProps={{
                title: "Connecting MS Teams",
                footer: null
            }}
            ref={thisRef}
            afterClose={afterClose}
        >
            <LoadingIcon /> Waiting for MS Teams OAuth.
        </BaseModal>
    )
}

export default forwardRef(MSTeamsOAuthPopup);